import React from 'react';

import { TypographyListItem, Stack, Typography } from '@gogame/components';
import {
  DateValueFormatter,
  AmountFormatter,
  useCurrencyFormat,
} from '@gogame/intl-ts';

const Item = ({ period, amount }) => {
  const format = useCurrencyFormat({ currency: amount.currency });

  return (
    <TypographyListItem disableTypography tooltip={format(amount.amount)}>
      <Stack
        component={'span'}
        justifyContent={'space-between'}
        direction={'row'}
        spacing={3}
      >
        <span>
          <DateValueFormatter value={period[0]} template={'MMM'} />
        </span>
        <Typography
          variant={'inherit'}
          component={'span'}
          noWrap
          disableTooltip
        >
          <AmountFormatter {...amount} />
        </Typography>
      </Stack>
    </TypographyListItem>
  );
};

export default Item;
